import { fabric } from 'fabric';
import { b64toBlob, exportIMG } from '~core';
import { getState } from '~src/state';
import { cleanBase64, getMultiplier } from '~src/utils';
import Swal from 'sweetalert2';
import { getUser } from '~src/user';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';

export const handleExportToShare = async () => {
  const { user } = await getUser();
  if (user.org_pointer.tipo_istanza === 'demo') {
    Swal.fire({
      title: 'Attenzione!',
      html:
        'Non &egrave; possibile esportare immagini durante il periodo di prova. Contattaci per maggiori informazioni.',
      icon: 'warning',
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonText: 'Chiudi',

      confirmButtonColor: '#278e8e',
    });
    return;
  }

  let selection = window.canvas.getActiveObject();
  let blob;

  if (selection) {
    // fix to support selection of a single MagicFrame
    // in that case we add an invisible text object to the selection
    if (selection.type === 'MagicFrame') {
      const invisibleText = new fabric.Textbox('', {
        left: selection.left,
        top: selection.top,
        width: 0,
        height: 0,
      });
      selection = new fabric.ActiveSelection([selection, invisibleText], {
        canvas: window.canvas,
      });
    }
    const imageBase64 = cleanBase64(selection.toDataURL());
    blob = b64toBlob(imageBase64.base64, imageBase64.contentType);
  } else {
    const project = getState('selected.tipo');
    const image = exportIMG(
      1,
      project.outputDpi,
      'blob',
      'png',
      false,
      getMultiplier()
    );
    blob = image.blob;
  }

  const contentType = blob.type;
  const extension = contentType.split('/')[1];

  const metadata = getMetadata();
  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.${extension}`
  );

  const file = new File([blob], fileName, {
    type: contentType,
    lastModified: new Date().getTime(),
  });

  const shareData = {
    files: [file],
  };

  if (navigator.canShare(shareData)) {
    await navigator.share(shareData);
  } else {
    console.log('Browser does not support sharing.');
  }
};

window.exportToAttachment = handleExportToShare;
